onComplete(function () {
	const banner = document.getElementById("alerts");
	const isLogged = document.documentElement.getAttribute('data-logged') === 'true';

	if (isLogged || !sessionStorage.getItem("alertClosed")) {
		banner.style.display = "flex";
	}

});